import React, { useContext, useState } from "react";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../../utilities/url";
import axios from "axios";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import { Controller, useForm } from "react-hook-form";
import { FaPencilAlt, FaRegCopy, FaTrashAlt } from "react-icons/fa";
import {
  ButtonGroup,
  Card,
  Col,
  Dropdown,
  Form,
  ListGroup,
  Row,
} from "react-bootstrap";
import CustomStyles from "../../components/customStyles";
import { ThemeContext } from "../../provider/themeContext";
import storage from "../../services/storage";
import CryptoJS from "crypto-js";
import AddFunction from "./component/addFunction";
import EditFunction from "./component/editFunction";
import ImportTools from "./component/importTools";
import { v4 as uuidv4 } from "uuid";
import { ToastrContext } from "../../provider/toastrContext";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { format_number } from "../../utilities/ext-function";
import AddSubsPackage from "./component/addSubsPackage";
import EditSubsPackage from "./component/editSubsFunction";
import authService from "../../services/auth.service";
import { NumericFormat } from "react-number-format";
import { useRef } from "react";

import { FilePond, registerPlugin } from "react-filepond";
import "filepond/dist/filepond.min.css";

// Plugin opsional
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import PaymentModal from "./component/paymentModal";
import FileModal from "./component/fileModal";

registerPlugin(FilePondPluginFileValidateType, FilePondPluginFileValidateSize);

var $ = require("jquery");

const AddChatbot = () => {
  const { showCopy } = useContext(ToastrContext);
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const decryptWS = CryptoJS.AES.decrypt(storage.get("wrs"), "wrs").toString(
    CryptoJS.enc.Utf8
  );
  const workspace = JSON.parse(decryptWS);
  const [hideSpiner, setHideSpiner] = useState(true);
  const [load, setLoad] = useState(false);
  const dt_user = JSON.parse(localStorage.getItem("user"));
  const [assistant, setAssistant] = useState([]);
  const [selectedST, setSelectedST] = useState("free");
  const [selectedSA, setSelectedSA] = useState("public");
  const [subscriptionPackage, setSubscriptionPackage] = useState([]);
  const [delSubscriptionPackage, setDelSubscriptionPackage] = useState([]);
  const [functionS, setFunctionS] = useState([]);
  const [device, setDevice] = useState([]);
  const [leftItems, setLeftItems] = useState([]);
  const [rightItems, setRightItems] = useState([]);
  // Conversation analytics: per-OSA emotion + label taxonomy (t_osa_analytics_configuration).
  const [emotionRows, setEmotionRows] = useState([]);
  const [labelRows, setLabelRows] = useState([]);
  const [llmCatalog, setLlmCatalog] = useState({});

  const addEmotionRow = () =>
    setEmotionRows((rows) => [
      ...rows,
      { emotion: "", group: "neutral", condition: "" },
    ]);
  const removeEmotionRow = (index) =>
    setEmotionRows((rows) => rows.filter((_, i) => i !== index));
  const updateEmotionRow = (index, field, value) =>
    setEmotionRows((rows) =>
      rows.map((row, i) => (i === index ? { ...row, [field]: value } : row))
    );

  const addLabelRow = () =>
    setLabelRows((rows) => [...rows, { label: "", condition: "" }]);
  const removeLabelRow = (index) =>
    setLabelRows((rows) => rows.filter((_, i) => i !== index));
  const updateLabelRow = (index, field, value) =>
    setLabelRows((rows) =>
      rows.map((row, i) => (i === index ? { ...row, [field]: value } : row))
    );

  // Client-side validation mirroring otokata-core wh_osa_analytics_config.go so the user
  // gets immediate feedback; the api re-validates authoritatively. Returns an error
  // message string, or null when valid. Fully-empty rows are ignored (treated as "not set").
  const validateEmotionRows = (rows) => {
    const filled = rows.filter(
      (r) => r.emotion.trim() !== "" || r.condition.trim() !== ""
    );
    if (filled.length === 0) return null;
    if (filled.length > 50) return "Emotion taxonomy exceeds 50 entries.";
    const seen = new Set();
    for (const r of filled) {
      const key = r.emotion.trim();
      if (key === "") return "Each emotion needs a name.";
      if (r.condition.trim() === "")
        return `Emotion "${key}" needs a condition.`;
      if (seen.has(key)) return `Duplicate emotion "${key}".`;
      seen.add(key);
    }
    return null;
  };
  const validateLabelRows = (rows) => {
    const filled = rows.filter(
      (r) => r.label.trim() !== "" || r.condition.trim() !== ""
    );
    if (filled.length === 0) return null;
    if (filled.length > 50) return "Label taxonomy exceeds 50 entries.";
    const seen = new Set();
    for (const r of filled) {
      const key = r.label.trim();
      if (key === "") return "Each label needs a name.";
      if (/[\n\r]/.test(key)) return "Label must not contain newlines.";
      if (r.condition.trim() === "") return `Label "${key}" needs a condition.`;
      if (seen.has(key)) return `Duplicate label "${key}".`;
      seen.add(key);
    }
    return null;
  };
  // Build the JSON-string config sent to the api ("" = field not set / cleared).
  const buildEmotionConfig = (rows) => {
    const filled = rows
      .filter((r) => r.emotion.trim() !== "" && r.condition.trim() !== "")
      .map((r) => ({
        emotion: r.emotion.trim(),
        group: r.group || "neutral",
        condition: r.condition.trim(),
      }));
    return filled.length ? JSON.stringify({ emotions: filled }) : "";
  };
  const buildLabelingConfig = (rows) => {
    const filled = rows
      .filter((r) => r.label.trim() !== "" && r.condition.trim() !== "")
      .map((r) => ({ label: r.label.trim(), condition: r.condition.trim() }));
    return filled.length ? JSON.stringify({ labels: filled }) : "";
  };
  const [knwValue, setKnwValue] = useState("");
  const [files, setFiles] = useState([]);

  useEffect(() => {
    //Set Default Value Form
    setValue("expired", 50);
    setValue("followUpActive", false);
    // Get Assistant
    axios
      .post(
        `${API_URL}get-personal-assistant-list`,
        { idt_workspace: workspace.idt_user_workspace, limit: 500, page: 1 },
        {
          headers: {
            Authorization: `Bearer ${storage.get("access_token")}`,
          },
        }
      )
      .then((response) => {
        if (response.data.success === true) {
          const maps = response.data.data.data.map(function (d) {
            const map = {
              value: d.idt_user_assistant,
              label: d.name,
            };
            return map;
          });
          setAssistant(maps);
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });

    // Get LLM provider/model catalog (drives the optional LLM Provider section)
    axios
      .get(`${API_URL}llm-catalog`, {
        headers: {
          Authorization: `Bearer ${storage.get("access_token")}`,
        },
      })
      .then((response) => {
        if (response.data.success === true && response.data.data) {
          setLlmCatalog(response.data.data);
        }
      })
      .catch(() => {
        // Non-fatal: the section still works with free-text model entry.
      });

    // Get Device
    axios
      .post(
        `${API_URL}list-device`,
        {
          idt_workspace: workspace.idt_user_workspace,
        },
        {
          headers: {
            Authorization: `Bearer ${storage.get("access_token")}`,
          },
        }
      )
      .then((response) => {
        if (response.data.success === true) {
          const maps = response.data.data.map(function (d) {
            const map = {
              value: d.idt_device,
              label: d.name + " (" + d.msisdn + ")",
            };
            return map;
          });
          setDevice(maps);
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });

    //Get Operator
    axios
      .post(
        `${API_URL}user-group`,
        {
          idt_workspace: workspace.idt_user_workspace,
          role: ["admin", "operator"],
        },
        {
          headers: {
            Authorization: `Bearer ${storage.get("access_token")}`,
          },
        }
      )
      .then((response) => {
        if (response.data.success === true) {
          if (response.data.data) {
            const maps = response.data.data.map(function (d) {
              const map = {
                id: d.idt_user_workspace_member,
                name: d.name,
              };
              return map;
            });
            setLeftItems(maps);
          }
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  }, []);

  /* Copy */
  const handleCopyClick = () => {
    const valueToCopy = getValues("w_link");
    if (valueToCopy) {
      navigator.clipboard.writeText(valueToCopy);
      showCopy("Webchat Link copied to clipboard");
    }
  };
  const handleCopyClick2 = () => {
    const valueToCopy = getValues("w_widget");
    if (valueToCopy) {
      navigator.clipboard.writeText(valueToCopy);
      showCopy("Webchat Widget copied to clipboard");
    }
  };

  // Menangani pemindahan item terpilih ke panel kanan
  const handleMoveToRight = (item) => {
    setLeftItems(leftItems.filter((i) => i.id !== item.id));
    setRightItems([...rightItems, item]);
  };

  // Menangani pemindahan item kembali ke panel kiri
  const handleMoveToLeft = (item) => {
    setRightItems(rightItems.filter((i) => i.id !== item.id));
    setLeftItems([...leftItems, item]);
  };

  // Menangani pemindahan semua item dari kiri ke kanan
  const handleMoveAllToRight = () => {
    setRightItems([...rightItems, ...leftItems]);
    setLeftItems([]);
  };

  // Menangani pemindahan semua item dari kanan ke kiri
  const handleMoveAllToLeft = () => {
    setLeftItems([...leftItems, ...rightItems]);
    setRightItems([]);
  };

  const handleSTChange = (event) => {
    setSelectedST(event.target.value);
    if (event.target.value === "free") {
      setSelectedSA("public");
    } else {
      setSelectedSA("subscriber");
    }
  };
  const handleSAChange = (event) => {
    setSelectedSA(event.target.value);
  };

  const handleFunctionS = (data) => {
    setFunctionS((prevFunctionS) => {
      const isDuplicate = prevFunctionS.some((item) => item.name === data.name);
      if (isDuplicate) {
        return prevFunctionS;
      }
      return [...prevFunctionS, data];
    });
  };

  // Stage imported tools into the function list (create page has no idt_osa yet,
  // so they persist when the new bot is saved). Dedupe by name; append the draft
  // instructions for the user to review.
  const handleStageImported = (items, draftPrompt) => {
    setFunctionS((prev) => {
      const existing = new Set(prev.map((f) => f.name));
      const additions = items.filter((it) => !existing.has(it.name));
      return [...prev, ...additions];
    });
    if (draftPrompt) {
      const current = getValues("chatbotInstruction") || "";
      setValue(
        "chatbotInstruction",
        current ? `${current}\n\n${draftPrompt}` : draftPrompt
      );
    }
  };

  const updateFunctionS = (index, data) => {
    setFunctionS((prevFunctionS) =>
      prevFunctionS.map((func, i) =>
        i === index ? { ...func, ...data } : func
      )
    );
  };

  const deleteFunctionS = (name, description) => {
    setFunctionS((prevFunctionS) =>
      prevFunctionS.filter(
        (func) => !(func.name === name && func.description === description)
      )
    );
  };

  const handleSubsPackage = (data) => {
    setSubscriptionPackage((prevSubsPacakage) => [...prevSubsPacakage, data]);
  };

  const updateSubsPackage = (index, data) => {
    setSubscriptionPackage((prevSubsPacakage) =>
      prevSubsPacakage.map((subs, i) =>
        i === index ? { ...subs, ...data } : subs
      )
    );
  };

  const deleteSubsPackage = (id, name, description) => {
    setSubscriptionPackage((prevSubsPacakage) =>
      prevSubsPacakage.filter(
        (subs) => !(subs.name === name && subs.description === description)
      )
    );
    setDelSubscriptionPackage((prev) => [...prev, id]);
  };

  const expiredRef = useRef(null);
  const followUpRef = useRef(null);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    clearErrors,
    watch,
    trigger,
    setValue,
    getValues,
  } = useForm({
    reValidateMode: "onBlur",
  });

  const webchatLink = watch("w_link");

  const onError = (errors) => {
    if (errors.expired && expiredRef.current) {
      expiredRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
    if (errors.followUpIdle && followUpRef.current) {
      followUpRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  const descriptionLength = watch("chatbotDescription", "");
  const knowledgeLength = watch("chatbotKnowledge", "");
  const instructionLength = watch("chatbotInstruction", "");
  const resUnsubsLength = watch("resUnsubs", "");
  const resExpLength = watch("resExp", "");
  const resQuotaLength = watch("resQuota", "");
  const resCheckSubsLength = watch("resCheckSubs", "");
  const isFollowUpActive = watch("followUpActive");
  const llmProvider = watch("llmProvider", "");
  const followUpConditionLength = watch("followUpCondition", "");
  const followUpGoalLength = watch("followUpGoal", "");

  const onSubmit = (data) => {
    const createJsonSchemas = (functions) => {
      // Array untuk menyimpan schema dari tiap objek functionS
      const schemas = functions.map((func) => {
        const schema = {
          type: "object",
          properties: {},
          required: [],
        };
        // Proses setiap parameter di dalam array parameters
        func.parameters.forEach((param) => {
          schema.properties[param.name] = {
            type: param.type,
            description: param.description,
          };
          // Hanya tambahkan enum jika tidak kosong
          if (param.enum && param.enum.length > 0) {
            schema.properties[param.name].enum = param.enum;
          }
          // Jika required adalah true, tambahkan ke array required
          if (param.required) {
            schema.required.push(param.name);
          }
        });
        return {
          name: func.name,
          description: func.description,
          exec_type: func.exec_type,
          active: func.active,
          exec_type: func.exec_type,
          endpoint: func.endpoint,
          method: func.method,
          headers: func.headers,
          body_type: func.body_type,
          body: func.body,
          credentials: func.credentials,
          response_filter: func.response_filter,
          response_prompt: func.response_prompt,
          response_media_type: func.response_media_type,
          response_media_url: func.response_media_url,
          parameters: JSON.stringify(schema),
        };
      });
      return schemas;
    };

    // Validate the analytics taxonomy before submitting so the user gets a precise message.
    const emotionErr = validateEmotionRows(emotionRows);
    if (emotionErr) {
      toast.error(emotionErr, {
        position: "top-right",
        theme: "colored",
        transition: Slide,
        autoClose: 4000,
        hideProgressBar: true,
      });
      return;
    }
    const labelErr = validateLabelRows(labelRows);
    if (labelErr) {
      toast.error(labelErr, {
        position: "top-right",
        theme: "colored",
        transition: Slide,
        autoClose: 4000,
        hideProgressBar: true,
      });
      return;
    }

    // console.log(data);
    const datas = {
      name: data.serviceName,
      description: data.chatbotDescription,
      expired: data.expired,
      chatbotKnowledge: data.chatbotKnowledge,
      chatbotInstruction: data.chatbotInstruction,
      externalKnowledge: data.externalKnowledge,
      webchatLink: data.w_link,
      webchatWidget: data.w_widget,
      functions: createJsonSchemas(functionS),
      operator: rightItems.map((op) => op.id),
      device: data.device ? data.device.map((device) => device.value) : [],
      assistant: data.assistant.value,
      serviceType: selectedST,
      serviceAccess: selectedSA,
      workspace: workspace.idt_user_workspace,
      subscriptionPackage: subscriptionPackage,
      delSubscriptionPackage: delSubscriptionPackage,
      resUnsubs: data.resUnsubs,
      resExp: data.resExp,
      resQuota: data.resQuota,
      resCheckSubs: data.resCheckSubs,
      followUpActive: data.followUpActive ? "Y" : "N",
      followUpIdle: data.followUpIdle,
      followUpCount: data.followUpCount,
      followUpCondition: data.followUpCondition,
      followUpGoal: data.followUpGoal,
      emotionConfig: buildEmotionConfig(emotionRows),
      labelingConfig: buildLabelingConfig(labelRows),
      llmConfig: {
        provider: data.llmProvider || "",
        model: data.llmModel || "",
        base_url: data.llmBaseUrl || "",
        api_key: data.llmApiKey || "",
        region: data.llmRegion || "",
        thinking: data.llmThinking ? 1 : 0,
      },
    };
    // console.log(datas);

    axios
      .post(`${API_URL}add-chatbot`, datas, {
        headers: {
          Authorization: `Bearer ${storage.get("access_token")}`,
        },
      })
      .then((response) => {
        if (response.data.success === true) {
          localStorage.setItem("alert", true);
          navigate("/chatbot");
        } else {
          toast.error(response.data.message, {
            position: "top-right",
            theme: "colored",
            transition: Slide,
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  };

  // Generate
  const handleGenerateWCL = () => {
    const newUUID = uuidv4();
    setValue("w_link", "https://webchat.otokata.id/" + newUUID);
    const iframeHTML = `<iframe src="https://webchat.otokata.id/${newUUID}" style="position:fixed;bottom:20px;right:20px;width:350px;height:500px;border:none;box-shadow:0 0 10px rgba(0,0,0,0.3);z-index:9999;"></iframe>`;
    setValue("w_widget", iframeHTML);
    clearErrors("w_link");
  };

  // const handleGenerateWCW = () => {
  //   const iframeHTML = `<iframe src="${webchatLink}" style="position:fixed;bottom:20px;right:20px;width:350px;height:500px;border:none;box-shadow:0 0 10px rgba(0,0,0,0.3);z-index:9999;"></iframe>`;
  //   setValue("w_widget", iframeHTML);
  //   clearErrors("w_widget");
  // };

  // Modal Add Function
  const [showModal, setShowModal] = useState(false); // 'payment', 'file', or null
  const [showAddons, setShowAddons] = useState(false);
  const [show, setShow] = useState(false);
  const [showU, setShowU] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const handleShowImport = () => setShowImport(true);
  const handleCloseImport = () => setShowImport(false);
  const handleShowAddons = () => setShowAddons(true);
  const handleShow = () => setShow(true);
  const handleShowU = () => setShowU(true);
  const handleCloseAddons = () => {
    setShowAddons(false);
  };
  const handleClose = () => {
    setShow(false);
    setShowModal(false);
  };
  const handleCloseU = () => {
    setShowU(false);
    setShowEditModal(false);
  };
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedFunction, setSelectedFunction] = useState(null);
  const [functionIndex, setFunctionIndex] = useState(null);
  const handleEditFunction = (index, row) => {
    setShowU(true);
    setFunctionIndex(index);
    setSelectedFunction(row);
    setShowEditModal(true);
  };

  // Modal Add Subscription Package
  const [showSubs, setShowSubs] = useState(false);
  const [showSubsU, setShowSubsU] = useState(false);
  const handleShowSubs = () => setShowSubs(true);
  const handleShowSubsU = () => setShowSubsU(true);
  const handleCloseSubs = () => {
    setShowSubs(false);
  };
  const handleCloseSubsU = () => {
    setShowSubsU(false);
  };
  const [showEditModalSubs, setShowEditModalSubs] = useState(false);
  const [selectedSubs, setSelectedSubs] = useState(null);
  const [subsIndex, setSubsIndex] = useState(null);
  const handleEditSubs = (index, row) => {
    setShowSubsU(true);
    setSubsIndex(index);
    setSelectedSubs(row);
    setShowEditModalSubs(true);
  };

  return (
    <div className="container-fluid p-0">
      <div className="row mb-2 mb-xl-3">
        <div className="col-auto">
          <h5>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/chatbot">Chatbot</Link>
                </li>
                <li className="breadcrumb-item active">Create OSA Chatbot</li>
              </ol>
            </nav>
          </h5>
        </div>
        <ToastContainer />
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="card rounded-4 shadow-lg">
            <div className="col-md-11 col-sm-12 mx-auto">
              <div className="card-header rounded-4">
                <h5 className="card-title text-center">Create OSA Chatbot</h5>
                <ToastContainer />
              </div>
              <div className="card-body">
                <div className="card-body h-100">
                  <form onSubmit={handleSubmit(onSubmit, onError)}>
                    <div className="row">
                      <div className="col-md-10">
                        <div className="circle-number-container mb-4">
                          <div className="circle-number">1</div>
                          <div className="circle-text">
                            <span className="main-text">
                              Otokata Smart Assistant
                            </span>
                            <span className="sub-text">
                              Fill in the service name and assistant to be used.
                            </span>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-3 text-sm-right">
                            OSA Service Name
                            <span className="required">*</span>
                          </label>
                          <div className="col-sm-4 error-placeholder">
                            <input
                              type="text"
                              {...register("serviceName", {
                                required: "Service Name is required",
                              })}
                              className={`form-control ${
                                errors.serviceName ? "is-invalid" : ""
                              }`}
                            />
                            {errors.serviceName && (
                              <div className="invalid-feedback">
                                {errors.serviceName.message}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-3 text-sm-right">
                            Description
                            <span className="required">*</span>
                          </label>
                          <div className="col-sm-8 error-placeholder">
                            <textarea
                              {...register("chatbotDescription", {
                                required: "Description is required",
                              })}
                              className={`form-control ${
                                errors.chatbotDescription ? "is-invalid" : ""
                              }`}
                              rows={10}
                              maxLength={20000}
                              placeholder="Max. 20.000 Character"
                            />
                            <div className="d-flex justify-content-between">
                              {errors.chatbotDescription ? (
                                <div className="d-block invalid-feedback">
                                  {errors.chatbotDescription.message}
                                </div>
                              ) : (
                                <div></div>
                              )}
                              <div className="text-right">
                                {descriptionLength
                                  ? format_number(descriptionLength.length)
                                  : 0}
                                /20.000
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-3 text-sm-right">
                            Session Expiry (Min)
                            <span className="required">*</span>
                          </label>
                          <div
                            ref={expiredRef}
                            className="col-sm-4 error-placeholder"
                          >
                            <NumericFormat
                              value={watch("expired") || ""}
                              allowNegative={false}
                              thousandSeparator="."
                              decimalSeparator=","
                              allowLeadingZeros={false}
                              customInput="input"
                              getInputRef={(ref) => {
                                if (ref) {
                                  register("expired", {
                                    required: "Expired is required",
                                    min: {
                                      value: 5,
                                      message: "Minimum value is 5",
                                    },
                                    max: {
                                      value: 10080,
                                      message:
                                        "Maximum value is 10.080 (7 days)",
                                    },
                                  });
                                }
                              }}
                              onValueChange={({ value }) => {
                                setValue("expired", value);
                                clearErrors("expired");
                                trigger("expired");
                              }}
                              className={`form-control ${
                                errors.expired ? "is-invalid" : ""
                              }`}
                            />
                            {errors.expired && (
                              <div className="invalid-feedback">
                                {errors.expired.message}
                              </div>
                            )}
                          </div>
                          <div className="col-sm-5">
                            <p className="text-muted fs-12 mt-1 mb-0">
                              {(() => {
                                const val = parseInt(watch("expired") || "0");

                                if (!val) return "";

                                const days = Math.floor(val / 1440);
                                const remainingAfterDays = val % 1440;

                                const hours = Math.floor(
                                  remainingAfterDays / 60
                                );
                                const minutes = remainingAfterDays % 60;

                                const parts = [];
                                if (days) parts.push(`${days} days`);
                                if (hours) parts.push(`${hours} hours`);
                                if (minutes || (!days && !hours))
                                  parts.push(`${minutes} minutes`);

                                return parts.join(" ");
                              })()}
                            </p>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-3 text-sm-right">
                            Assistant
                            <span className="required">*</span>
                          </label>
                          <div className="col-sm-4 error-placeholder">
                            <Controller
                              name="assistant"
                              control={control}
                              className={`${
                                errors.assistant ? "is-invalid" : ""
                              }`}
                              rules={{
                                required: "Assistant is required.",
                              }}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  styles={CustomStyles(theme)}
                                  className="custom-select"
                                  maxMenuHeight={200}
                                  options={assistant}
                                  placeholder="Select Assistant"
                                  onBlur={field.onBlur}
                                  onChange={(selected) => {
                                    field.onChange(selected);
                                    clearErrors("assistant");
                                  }}
                                  isSearchable={true}
                                  // isDisabled={!selectedCategory}
                                />
                              )}
                            />
                            {errors.assistant && (
                              <p className="errorMsg">
                                {errors.assistant.message}
                              </p>
                            )}
                          </div>
                        </div>
                        <hr />
                        <div className="circle-number-container mb-4">
                          <div className="circle-number">2</div>
                          <div className="circle-text">
                            <span className="main-text">
                              Knowledge Reference
                            </span>
                            <span className="sub-text">
                              Fill in the Knowledge Reference to be used.
                            </span>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-3 text-sm-right">
                            Chatbot Knowledge
                          </label>
                          <div className="col-sm-8 error-placeholder">
                            {/* <ReactQuill
                              value={knwValue}
                              onChange={setKnwValue}
                            /> */}
                            <textarea
                              {...register("chatbotKnowledge")}
                              className={`form-control ${
                                errors.chatbotKnowledge ? "is-invalid" : ""
                              }`}
                              rows={10}
                              maxLength={20000}
                              placeholder="Max. 20.000 Character"
                            />
                            <div className="text-end">
                              {knowledgeLength
                                ? format_number(knowledgeLength.length)
                                : 0}
                              /20.000
                            </div>
                            {errors.chatbotKnowledge && (
                              <div className="invalid-feedback">
                                {errors.chatbotKnowledge.message}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-3 text-sm-right">
                            Upload Knowledge
                          </label>
                          <div className="col-sm-6">
                            <FilePond
                              files={files}
                              onupdatefiles={setFiles}
                              allowMultiple={false}
                              name="knowledgeFiles"
                              labelIdle='Drag & Drop file atau <span class="filepond--label-action">Browse</span>'
                              acceptedFileTypes={[
                                "application/pdf",
                                "application/msword",
                                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                              ]}
                              maxFileSize="100MB"
                            />
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-3 text-sm-right">
                            External Knowledge
                          </label>
                          <div className="col-sm-2">
                            <select className="form-select">
                              <option value="otobaca">Otobaca</option>
                            </select>
                          </div>
                          <div className="col-sm-4 error-placeholder">
                            <input
                              type="text"
                              {...register("externalKnowledge")}
                              className={`form-control ${
                                errors.externalKnowledge ? "is-invalid" : ""
                              }`}
                            />
                            {errors.externalKnowledge && (
                              <div className="invalid-feedback">
                                {errors.externalKnowledge.message}
                              </div>
                            )}
                          </div>
                        </div>
                        <hr />
                        <div className="circle-number-container mb-4">
                          <div className="circle-number">3</div>
                          <div className="circle-text">
                            <span className="main-text">OSA Functions</span>
                            <span className="sub-text">
                              Fill in the Smart Assistant Function to be used.
                            </span>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-3 text-sm-right">
                            OSA Function
                          </label>
                          <div className="col-sm-8 error-placeholder">
                            <div className="d-flex align-items-center">
                              <a
                                className="btn btn-info me-2"
                                onClick={handleShow}
                              >
                                Add Custom Function
                              </a>

                              <a
                                className="btn btn-primary me-2"
                                onClick={handleShowImport}
                              >
                                Import from URL
                              </a>

                              <Dropdown className="position-relative">
                                <Dropdown.Toggle
                                  variant="warning"
                                  id="dropdown-button"
                                >
                                  Add-Ons Function
                                </Dropdown.Toggle>

                                <Dropdown.Menu style={{ marginTop: "2.25rem" }}>
                                  <Dropdown.Item
                                    onClick={() => setShowModal("payment")}
                                  >
                                    Payment
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => setShowModal("file")}
                                  >
                                    File
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                            {functionS.length > 0 && (
                              <div className="table-responsive mt-3">
                                <table className="table table-bordered table-custome">
                                  <thead>
                                    <tr
                                      className="text-white"
                                      style={{ backgroundColor: "#13213c" }}
                                    >
                                      <th className="p-2">Name</th>
                                      <th className="p-2">Description</th>
                                      <th className="d-none d-md-table-cell p-2">
                                        Parameters
                                      </th>
                                      <th
                                        align="center"
                                        className="text-center p-2"
                                      >
                                        Actions
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {functionS.map((row, index) => (
                                      <tr key={index}>
                                        <td className="p-2">{row.name}</td>
                                        <td className="p-2">
                                          {row.description}
                                        </td>
                                        <td className="d-none d-md-table-cell p-2">
                                          {row.parameters
                                            .map((rowp) => rowp.name)
                                            .join(", ")}
                                        </td>
                                        <td align="center" className="p-2">
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "center",
                                            }}
                                          >
                                            <a
                                              onClick={() =>
                                                handleEditFunction(index, row)
                                              }
                                              className="btn-none"
                                              style={{ color: "#0275d8" }}
                                            >
                                              <FaPencilAlt />
                                            </a>
                                            <a
                                              onClick={() =>
                                                deleteFunctionS(
                                                  row.name,
                                                  row.description
                                                )
                                              }
                                              className="btn-none"
                                              style={{
                                                color: "#d9534f",
                                                marginLeft: "10px",
                                              }} // Optional spacing
                                            >
                                              <FaTrashAlt />
                                            </a>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                        <hr />
                        <div className="circle-number-container mb-4">
                          <div className="circle-number">4</div>
                          <div className="circle-text">
                            <span className="main-text">
                              Chatbot Instruction
                            </span>
                            <span className="sub-text">
                              Fill define specific instruction or task for your
                              chabot.
                            </span>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-3 text-sm-right">
                            Chatbot Instruction
                          </label>
                          <div className="col-sm-8 error-placeholder">
                            <textarea
                              {...register("chatbotInstruction")}
                              className={`form-control ${
                                errors.chatbotInstruction ? "is-invalid" : ""
                              }`}
                              rows={10}
                              maxLength={20000}
                              placeholder="Max. 20.000 Character"
                            />
                            <div className="text-end">
                              {instructionLength
                                ? format_number(instructionLength.length)
                                : 0}
                              /20.000
                            </div>
                            {errors.chatbotInstruction && (
                              <div className="invalid-feedback">
                                {errors.chatbotInstruction.message}
                              </div>
                            )}
                          </div>
                        </div>
                        <hr />
                        <div className="circle-number-container mb-4">
                          <div className="circle-number">5</div>
                          <div className="circle-text">
                            <span className="main-text">Device Assignment</span>
                            <span className="sub-text">
                              Fill in device to be used.
                            </span>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-3 text-sm-right">
                            Device Setting
                          </label>
                          <div className="col-sm-4 error-placeholder">
                            <Controller
                              name="device"
                              control={control}
                              className={`${errors.device ? "is-invalid" : ""}`}
                              // rules={{
                              //   required: "Device is required.",
                              // }}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  isMulti
                                  styles={CustomStyles(theme)}
                                  className="custom-select"
                                  maxMenuHeight={200}
                                  options={device}
                                  placeholder="Select Device"
                                  onBlur={field.onBlur}
                                  onChange={(selected) => {
                                    field.onChange(selected);
                                    clearErrors("device");
                                  }}
                                  isSearchable={true}
                                  // isDisabled={!selectedCategory}
                                />
                              )}
                            />
                            {errors.device && (
                              <p className="errorMsg text-danger fs-7">
                                {errors.device.message}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-3 text-sm-right">
                            Webchat Link
                          </label>
                          <div className="col-sm-6 error-placeholder">
                            <div className="input-group mb-2 mr-sm-2">
                              <input
                                type="text"
                                {...register("w_link")}
                                className={`form-control ${
                                  errors.w_link ? "is-invalid" : ""
                                }`}
                                readOnly="readonly"
                              />
                              <div
                                className="input-group-text c-pointer"
                                onClick={handleCopyClick}
                              >
                                <FaRegCopy />
                              </div>
                              {errors.w_link && (
                                <div className="invalid-feedback">
                                  {errors.w_link.message}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <button
                              className="btn btn-primary"
                              type="button"
                              onClick={handleGenerateWCL}
                            >
                              Generate
                            </button>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-3 text-sm-right">
                            Webchat Widget
                          </label>
                          <div className="col-sm-6 error-placeholder">
                            <div className="input-group mb-2 mr-sm-2">
                              <input
                                type="text"
                                {...register("w_widget")}
                                className={`form-control ${
                                  errors.w_widget ? "is-invalid" : ""
                                }`}
                                readOnly="readonly"
                                // ref={inputRef2}
                              />
                              <div
                                className="input-group-text c-pointer"
                                onClick={handleCopyClick2}
                              >
                                <FaRegCopy />
                              </div>
                              {errors.w_widget && (
                                <div className="invalid-feedback">
                                  {errors.w_widget.message}
                                </div>
                              )}
                            </div>
                          </div>
                          {/* <div className="col-sm-2">
                            {webchatLink ? (
                              <button
                                className="btn btn-primary"
                                type="button"
                                onClick={handleGenerateWCW}
                              >
                                Generate
                              </button>
                            ) : null}
                          </div> */}
                        </div>
                        <hr />
                        <div className="circle-number-container mb-4">
                          <div className="circle-number">6</div>
                          <div className="circle-text">
                            <span className="main-text">
                              Operator Assignment
                            </span>
                            <span className="sub-text">
                              Fill in operator to be used.
                            </span>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-3 text-sm-right">
                            Select Operator
                          </label>
                          <div className="col-sm-8 error-placeholder">
                            <Row className="mt-3">
                              <Col xl={5}>
                                <Card>
                                  <Card.Header style={{ padding: "10px" }}>
                                    Available Operators
                                  </Card.Header>
                                  <Card.Body
                                    style={{
                                      padding: "10px",
                                      height: "200px",
                                      overflowY: "auto",
                                    }}
                                  >
                                    <ListGroup>
                                      {leftItems.map((item) => (
                                        <ListGroup.Item
                                          style={{ padding: "5px" }}
                                          key={item.id}
                                          action
                                          onClick={() =>
                                            handleMoveToRight(item)
                                          }
                                        >
                                          {item.name}{" "}
                                        </ListGroup.Item>
                                      ))}
                                    </ListGroup>
                                  </Card.Body>
                                </Card>
                              </Col>
                              <Col
                                xl={2}
                                className="d-flex flex-column align-items-center justify-content-center"
                              >
                                <Button
                                  variant="primary"
                                  style={{ margin: "10px" }}
                                  onClick={handleMoveAllToRight}
                                >
                                  {">>"}
                                </Button>
                                <Button
                                  variant="primary"
                                  style={{ margin: "10px" }}
                                  onClick={handleMoveAllToLeft}
                                >
                                  {"<<"}
                                </Button>
                              </Col>
                              <Col xl={5}>
                                <Card>
                                  <Card.Header style={{ padding: "10px" }}>
                                    Selected Operators
                                  </Card.Header>
                                  <Card.Body
                                    style={{
                                      padding: "10px",
                                      height: "200px",
                                      overflowY: "auto",
                                    }}
                                  >
                                    <ListGroup>
                                      {rightItems.map((item) => (
                                        <ListGroup.Item
                                          style={{ padding: "5px" }}
                                          key={item.id}
                                          action
                                          variant="success"
                                          onClick={() => handleMoveToLeft(item)}
                                        >
                                          {item.name}
                                        </ListGroup.Item>
                                      ))}
                                    </ListGroup>
                                  </Card.Body>
                                </Card>
                              </Col>
                            </Row>
                          </div>
                        </div>
                        <hr />
                        <div className="circle-number-container mb-4">
                          <div className="circle-number">7</div>
                          <div className="circle-text">
                            <span className="main-text">
                              Follow Up & Closing
                            </span>
                            <span className="sub-text">
                              Fill details for Follow Up & Closing.
                            </span>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-3 text-sm-right">
                            Use Follow Up
                          </label>
                          <div className="col-sm-6 error-placeholder">
                            <Controller
                              name="followUpActive"
                              control={control}
                              render={({ field }) => (
                                <Form.Check
                                  type="switch"
                                  id="custom-switch-form"
                                  style={{ height: "20px" }}
                                  {...field} // Menyebarkan props ke Form.Check
                                  checked={field.value} // Mengontrol nilai dari React Hook Form
                                />
                              )}
                            />
                          </div>
                        </div>
                        {isFollowUpActive && (
                          <>
                            <div className="mb-3 row">
                              <label className="col-form-label col-sm-3 text-sm-right">
                                Idle Time (Min)
                                <span className="required">*</span>
                              </label>
                              <div
                                ref={followUpRef}
                                className="col-sm-4 error-placeholder"
                              >
                                <NumericFormat
                                  value={watch("followUpIdle") || ""}
                                  allowNegative={false}
                                  thousandSeparator="."
                                  decimalSeparator=","
                                  allowLeadingZeros={false}
                                  customInput="input"
                                  getInputRef={(ref) => {
                                    if (ref) {
                                      register("followUpIdle", {
                                        required: "followUpIdle is required",
                                        min: {
                                          value: 1,
                                          message: "Minimum value is 1",
                                        },
                                        max: {
                                          value: 10080,
                                          message:
                                            "Maximum value is 10.080 (7 days)",
                                        },
                                      });
                                    }
                                  }}
                                  onValueChange={({ value }) => {
                                    setValue("followUpIdle", value);
                                    clearErrors("followUpIdle");
                                    trigger("followUpIdle");
                                  }}
                                  className={`form-control ${
                                    errors.followUpIdle ? "is-invalid" : ""
                                  }`}
                                />
                                {errors.followUpIdle && (
                                  <div className="invalid-feedback">
                                    {errors.followUpIdle.message}
                                  </div>
                                )}
                              </div>
                              <div className="col-sm-5">
                                <p className="text-muted fs-12 mt-1 mb-0">
                                  {(() => {
                                    const val = parseInt(
                                      watch("followUpIdle") || "0"
                                    );

                                    if (!val) return "";

                                    const days = Math.floor(val / 1440);
                                    const remainingAfterDays = val % 1440;

                                    const hours = Math.floor(
                                      remainingAfterDays / 60
                                    );
                                    const minutes = remainingAfterDays % 60;

                                    const parts = [];
                                    if (days) parts.push(`${days} days`);
                                    if (hours) parts.push(`${hours} hours`);
                                    if (minutes || (!days && !hours))
                                      parts.push(`${minutes} minutes`);

                                    return parts.join(" ");
                                  })()}
                                </p>
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="col-form-label col-sm-3 text-sm-right">
                                Max Follow Up
                                <span className="required">*</span>
                              </label>
                              <div className="col-sm-4 error-placeholder">
                                <input
                                  type="number"
                                  {...register("followUpCount", {
                                    required: "Max Follow Up is required",
                                    min: {
                                      value: 1,
                                      message: "Minimum value is 1",
                                    },
                                    max: {
                                      value: 10,
                                      message: "Maximum value is 10",
                                    },
                                  })}
                                  className={`form-control ${
                                    errors.followUpCount ? "is-invalid" : ""
                                  }`}
                                />
                                {errors.followUpCount && (
                                  <div className="invalid-feedback">
                                    {errors.followUpCount.message}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="col-form-label col-sm-3 text-sm-right">
                                Follow Up Condition
                                <span className="required">*</span>
                              </label>
                              <div className="col-sm-8 error-placeholder">
                                <textarea
                                  {...register("followUpCondition", {
                                    required: "Follow Up Condition is required",
                                  })}
                                  className={`form-control ${
                                    errors.followUpCondition ? "is-invalid" : ""
                                  }`}
                                  rows={10}
                                  maxLength={20000}
                                  placeholder="Max. 20.000 Character"
                                />
                                <div className="text-end">
                                  {followUpConditionLength
                                    ? format_number(
                                        followUpConditionLength.length
                                      )
                                    : 0}
                                  /20.000
                                </div>
                                {errors.followUpCondition && (
                                  <div className="invalid-feedback">
                                    {errors.followUpCondition.message}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="col-form-label col-sm-3 text-sm-right">
                                Follow Up Goal
                                <span className="required">*</span>
                              </label>
                              <div className="col-sm-8 error-placeholder">
                                <textarea
                                  {...register("followUpGoal", {
                                    required: "Follow Up Goal is required",
                                  })}
                                  className={`form-control ${
                                    errors.followUpGoal ? "is-invalid" : ""
                                  }`}
                                  rows={10}
                                  maxLength={20000}
                                  placeholder="Max. 20.000 Character"
                                />
                                <div className="text-end">
                                  {followUpGoalLength
                                    ? format_number(followUpGoalLength.length)
                                    : 0}
                                  /20.000
                                </div>
                                {errors.followUpGoal && (
                                  <div className="invalid-feedback">
                                    {errors.followUpGoal.message}
                                  </div>
                                )}
                              </div>
                            </div>
                          </>
                        )}
                        <hr />
                        <div className="circle-number-container mb-4">
                          <div className="circle-number">8</div>
                          <div className="circle-text">
                            <span className="main-text">
                              OSA Chatbot Publish
                            </span>
                            <span className="sub-text">
                              Fill the Chatbot Publish Settings to be used.
                            </span>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-3 text-sm-right">
                            Service Type
                          </label>
                          <div className="col-sm-8 error-placeholder">
                            <div className="d-flex gap-3 mt-1">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="service_type"
                                  value="free"
                                  checked={selectedST === "free"}
                                  onChange={handleSTChange}
                                  id="free"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="free"
                                >
                                  Free
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="service_type"
                                  value="paid"
                                  checked={selectedST === "paid"}
                                  onChange={handleSTChange}
                                  id="paid"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="paid"
                                >
                                  Paid
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        {selectedST === "paid" && (
                          <>
                            <div className="mb-3 row">
                              <label className="col-form-label col-sm-3 text-sm-right">
                                Subscription Package
                              </label>
                              <div className="col-sm-8 error-placeholder">
                                {subscriptionPackage.length < 3 && (
                                  <a
                                    className="btn btn-info mb-3"
                                    onClick={handleShowSubs}
                                  >
                                    Create Subscription Package
                                  </a>
                                )}
                                {subscriptionPackage.length > 0 && (
                                  <div className="table-responsive">
                                    <table className="table table-bordered table-custome">
                                      <thead>
                                        <tr
                                          className="text-white"
                                          style={{ backgroundColor: "#13213c" }}
                                        >
                                          <th className="p-2">Name</th>
                                          <th className="p-2">Code</th>
                                          <th className="p-2">Description</th>
                                          <th className="d-none d-md-table-cell p-2">
                                            Quota
                                          </th>
                                          <th className="d-none d-md-table-cell p-2">
                                            Validity Period (days)
                                          </th>
                                          <th className="d-none d-md-table-cell p-2">
                                            Price (IDR)
                                          </th>
                                          <th
                                            align="center"
                                            className="text-center p-2"
                                          >
                                            Actions
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {subscriptionPackage.map(
                                          (row, index) => (
                                            <tr key={index}>
                                              <td className="p-2">
                                                {row.name}
                                              </td>
                                              <td className="p-2">
                                                {row.package_id}
                                              </td>
                                              <td className="p-2">
                                                {row.description
                                                  ? row.description
                                                  : "-"}
                                              </td>
                                              <td className="d-none d-md-table-cell text-end p-2">
                                                {format_number(row.quota)}
                                              </td>
                                              <td className="d-none d-md-table-cell text-end p-2">
                                                {format_number(row.subs_length)}
                                              </td>
                                              <td className="d-none d-md-table-cell text-end p-2">
                                                {format_number(row.price)}
                                              </td>
                                              <td
                                                align="center"
                                                className="px-2"
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                  }}
                                                >
                                                  <a
                                                    onClick={() =>
                                                      handleEditSubs(index, row)
                                                    }
                                                    className="btn-none"
                                                    style={{ color: "#0275d8" }}
                                                  >
                                                    <FaPencilAlt />
                                                  </a>
                                                  <a
                                                    onClick={() =>
                                                      deleteSubsPackage(
                                                        row.idt_osa_subscription_package,
                                                        row.name,
                                                        row.description
                                                      )
                                                    }
                                                    className="btn-none"
                                                    style={{
                                                      color: "#d9534f",
                                                      marginLeft: "10px",
                                                    }} // Optional spacing
                                                  >
                                                    <FaTrashAlt />
                                                  </a>
                                                </div>
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="col-form-label col-sm-3 text-sm-right">
                                Message Response Unsubscribe
                              </label>
                              <div className="col-sm-8 error-placeholder">
                                <textarea
                                  {...register("resUnsubs")}
                                  className={`form-control ${
                                    errors.resUnsubs ? "is-invalid" : ""
                                  }`}
                                  rows={10}
                                  maxLength={500}
                                  placeholder="Max. 500 Character"
                                />
                                <div className="text-end">
                                  {resUnsubsLength
                                    ? format_number(resUnsubsLength.length)
                                    : 0}
                                  /500
                                </div>
                                {errors.resUnsubs && (
                                  <div className="invalid-feedback">
                                    {errors.resUnsubs.message}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="col-form-label col-sm-3 text-sm-right">
                                Message Response Expiring
                              </label>
                              <div className="col-sm-8 error-placeholder">
                                <textarea
                                  {...register("resExp")}
                                  className={`form-control ${
                                    errors.resExp ? "is-invalid" : ""
                                  }`}
                                  rows={10}
                                  maxLength={500}
                                  placeholder="Max. 500 Character"
                                />
                                <div className="text-end">
                                  {resExpLength
                                    ? format_number(resExpLength.length)
                                    : 0}
                                  /500
                                </div>
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="col-form-label col-sm-3 text-sm-right">
                                Message Response Quota Depleting
                              </label>
                              <div className="col-sm-8 error-placeholder">
                                <textarea
                                  {...register("resQuota")}
                                  className={`form-control ${
                                    errors.resQuota ? "is-invalid" : ""
                                  }`}
                                  rows={10}
                                  maxLength={500}
                                  placeholder="Max. 500 Character"
                                />
                                <div className="text-end">
                                  {resQuotaLength
                                    ? format_number(resQuotaLength.length)
                                    : 0}
                                  /500
                                </div>
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="col-form-label col-sm-3 text-sm-right">
                                Message Response Check Subscription
                              </label>
                              <div className="col-sm-8 error-placeholder">
                                <textarea
                                  {...register("resCheckSubs")}
                                  className={`form-control ${
                                    errors.resCheckSubs ? "is-invalid" : ""
                                  }`}
                                  rows={10}
                                  maxLength={500}
                                  placeholder="Max. 500 Character"
                                />
                                <div className="text-end">
                                  {resCheckSubsLength
                                    ? format_number(resCheckSubsLength.length)
                                    : 0}
                                  /500
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                        <hr />
                        <div className="circle-number-container mb-4">
                          <div className="circle-number">9</div>
                          <div className="circle-text">
                            <span className="main-text">
                              LLM Provider (Optional)
                            </span>
                            <span className="sub-text">
                              Override the language model for this OSA. Leave the
                              provider on "Use global default" to inherit the
                              system configuration.
                            </span>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-3 text-sm-right">
                            Provider
                          </label>
                          <div className="col-sm-4">
                            <select
                              className="form-control"
                              {...register("llmProvider")}
                            >
                              <option value="">Use global default</option>
                              <option value="openai">OpenAI / Compatible</option>
                              <option value="anthropic">Anthropic (Claude)</option>
                              <option value="gemini">Google Gemini</option>
                              <option value="bedrock">AWS Bedrock</option>
                            </select>
                          </div>
                        </div>
                        {llmProvider && (
                          <>
                            <div className="mb-3 row">
                              <label className="col-form-label col-sm-3 text-sm-right">
                                Model
                              </label>
                              <div className="col-sm-4">
                                <input
                                  list="llmModelOptions"
                                  className="form-control"
                                  placeholder="Select or type a model name"
                                  {...register("llmModel")}
                                />
                                <datalist id="llmModelOptions">
                                  {(llmCatalog[llmProvider] || []).map((m) => (
                                    <option key={m.model_id} value={m.model_id}>
                                      {m.label}
                                    </option>
                                  ))}
                                  {llmProvider === "openai" &&
                                    (llmCatalog["compatible"] || []).map((m) => (
                                      <option key={m.model_id} value={m.model_id}>
                                        {m.label}
                                      </option>
                                    ))}
                                </datalist>
                                <small className="text-muted">
                                  Blank = use the global default model.
                                </small>
                              </div>
                            </div>
                            {llmProvider === "openai" && (
                              <div className="mb-3 row">
                                <label className="col-form-label col-sm-3 text-sm-right">
                                  Base URL
                                </label>
                                <div className="col-sm-5">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="OpenAI-compatible gateway (Ollama, vLLM, DeepSeek, Groq, ...)"
                                    {...register("llmBaseUrl")}
                                  />
                                  <small className="text-muted">
                                    Leave blank for OpenAI itself.
                                  </small>
                                </div>
                              </div>
                            )}
                            {llmProvider === "bedrock" && (
                              <div className="mb-3 row">
                                <label className="col-form-label col-sm-3 text-sm-right">
                                  AWS Region
                                </label>
                                <div className="col-sm-4">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="us-east-1"
                                    {...register("llmRegion")}
                                  />
                                </div>
                              </div>
                            )}
                            {llmProvider !== "bedrock" && (
                              <div className="mb-3 row">
                                <label className="col-form-label col-sm-3 text-sm-right">
                                  API Key
                                </label>
                                <div className="col-sm-4">
                                  <input
                                    type="password"
                                    className="form-control"
                                    autoComplete="new-password"
                                    placeholder="Leave blank to use the global key"
                                    {...register("llmApiKey")}
                                  />
                                </div>
                              </div>
                            )}
                            <div className="mb-3 row">
                              <label className="col-form-label col-sm-3 text-sm-right">
                                Enable Thinking
                              </label>
                              <div className="col-sm-8 d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  className="form-check-input mt-0"
                                  {...register("llmThinking")}
                                />
                                <small className="text-muted ms-2">
                                  For reasoning-capable models (Claude / Gemini /
                                  Bedrock / o-series).
                                </small>
                              </div>
                            </div>
                          </>
                        )}
                        <hr />
                        <div className="circle-number-container mb-4">
                          <div className="circle-number">10</div>
                          <div className="circle-text">
                            <span className="main-text">
                              Conversation Analytics
                            </span>
                            <span className="sub-text">
                              Define the emotion and label taxonomy used to
                              analyze each expired conversation session.
                            </span>
                          </div>
                        </div>
                        {/* Emotion taxonomy */}
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-3 text-sm-right">
                            Emotion Analysis
                          </label>
                          <div className="col-sm-8 error-placeholder">
                            <p
                              className="text-muted mb-2"
                              style={{ fontSize: "0.85rem" }}
                            >
                              Leave empty to use the default categories (positive
                              / neutral / negative).
                            </p>
                            {emotionRows.length > 0 && (
                              <div className="table-responsive mb-2">
                                <table className="table table-bordered table-custome">
                                  <thead>
                                    <tr
                                      className="text-white"
                                      style={{ backgroundColor: "#13213c" }}
                                    >
                                      <th className="p-2">Emotion</th>
                                      <th className="p-2">Group</th>
                                      <th className="p-2">Condition</th>
                                      <th
                                        align="center"
                                        className="text-center p-2"
                                      >
                                        Actions
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {emotionRows.map((row, index) => (
                                      <tr key={index}>
                                        <td className="p-2">
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={row.emotion}
                                            maxLength={30}
                                            placeholder="e.g. happy"
                                            onChange={(e) =>
                                              updateEmotionRow(
                                                index,
                                                "emotion",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </td>
                                        <td className="p-2">
                                          <select
                                            className="form-control"
                                            value={row.group}
                                            onChange={(e) =>
                                              updateEmotionRow(
                                                index,
                                                "group",
                                                e.target.value
                                              )
                                            }
                                          >
                                            <option value="positive">
                                              positive
                                            </option>
                                            <option value="neutral">
                                              neutral
                                            </option>
                                            <option value="negative">
                                              negative
                                            </option>
                                          </select>
                                        </td>
                                        <td className="p-2">
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={row.condition}
                                            placeholder="condition evaluated by the AI"
                                            onChange={(e) =>
                                              updateEmotionRow(
                                                index,
                                                "condition",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </td>
                                        <td align="center" className="px-2">
                                          <a
                                            onClick={() =>
                                              removeEmotionRow(index)
                                            }
                                            className="btn-none"
                                            style={{ color: "#d9534f" }}
                                          >
                                            <FaTrashAlt />
                                          </a>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            )}
                            {emotionRows.length < 50 && (
                              <a
                                className="btn btn-info"
                                onClick={addEmotionRow}
                              >
                                Add Emotion
                              </a>
                            )}
                          </div>
                        </div>
                        {/* Labeling taxonomy */}
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-3 text-sm-right">
                            Labeling
                          </label>
                          <div className="col-sm-8 error-placeholder">
                            <p
                              className="text-muted mb-2"
                              style={{ fontSize: "0.85rem" }}
                            >
                              Leave empty to disable labeling. A session can match
                              more than one label.
                            </p>
                            {labelRows.length > 0 && (
                              <div className="table-responsive mb-2">
                                <table className="table table-bordered table-custome">
                                  <thead>
                                    <tr
                                      className="text-white"
                                      style={{ backgroundColor: "#13213c" }}
                                    >
                                      <th className="p-2">Label</th>
                                      <th className="p-2">Condition</th>
                                      <th
                                        align="center"
                                        className="text-center p-2"
                                      >
                                        Actions
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {labelRows.map((row, index) => (
                                      <tr key={index}>
                                        <td className="p-2">
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={row.label}
                                            maxLength={50}
                                            placeholder="e.g. complaint"
                                            onChange={(e) =>
                                              updateLabelRow(
                                                index,
                                                "label",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </td>
                                        <td className="p-2">
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={row.condition}
                                            placeholder="condition that applies the label"
                                            onChange={(e) =>
                                              updateLabelRow(
                                                index,
                                                "condition",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </td>
                                        <td align="center" className="px-2">
                                          <a
                                            onClick={() => removeLabelRow(index)}
                                            className="btn-none"
                                            style={{ color: "#d9534f" }}
                                          >
                                            <FaTrashAlt />
                                          </a>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            )}
                            {labelRows.length < 50 && (
                              <a className="btn btn-info" onClick={addLabelRow}>
                                Add Label
                              </a>
                            )}
                          </div>
                        </div>
                        {/* <div className="mb-3 row">
                          <label className="col-form-label col-sm-3 text-sm-right">
                            Service Access
                            <span className="required">*</span>
                          </label>
                          <div className="col-sm-8 error-placeholder">
                            <div className="d-flex gap-3">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="service_access"
                                  value="public"
                                  checked={selectedSA === "public"}
                                  onChange={handleSAChange}
                                  id="public"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="public"
                                >
                                  Public
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="service_access"
                                  value="susbscriber"
                                  checked={selectedSA === "susbscriber"}
                                  onChange={handleSAChange}
                                  id="susbscriber"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="susbscriber"
                                >
                                  Subscriber
                                </label>
                              </div>
                            </div>
                          </div>
                        </div> */}
                      </div>
                    </div>
                    {/* <hr className="mb-4"></hr> */}
                    <div className="mt-4">
                      <Link to="/chatbot" className="btn btn-danger btn-md">
                        Cancel
                      </Link>
                      <button
                        type="submit"
                        className="btn btn-success btn-md float-end"
                      >
                        <span
                          className={`spinner-border spinner-border-xs me-2 ${
                            hideSpiner ? "d-none" : ""
                          }`}
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Submit
                      </button>
                    </div>
                  </form>
                  {/* Modal */}
                  <PaymentModal
                    show={showModal === "payment"}
                    handleFunctionS={handleFunctionS}
                    onClose={handleClose}
                  />
                  <FileModal
                    show={showModal === "file"}
                    handleFunctionS={handleFunctionS}
                    onClose={handleClose}
                  />
                  <AddFunction
                    functionS={functionS}
                    handleFunctionS={handleFunctionS}
                    show={show}
                    handleClose={handleClose}
                  />
                  <ImportTools
                    show={showImport}
                    handleClose={handleCloseImport}
                    onStage={handleStageImported}
                  />
                  {showEditModal && (
                    <EditFunction
                      show={showU}
                      i={functionIndex}
                      functionS={selectedFunction}
                      updateFunctionS={updateFunctionS}
                      handleClose={handleCloseU}
                    />
                  )}
                  <AddSubsPackage
                    handleSubsPackage={handleSubsPackage}
                    show={showSubs}
                    handleClose={handleCloseSubs}
                  />
                  {showEditModalSubs && (
                    <EditSubsPackage
                      show={showSubsU}
                      i={subsIndex}
                      selectedSubs={selectedSubs}
                      updateSubs={updateSubsPackage}
                      handleClose={handleCloseSubsU}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddChatbot;
